import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse } from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';

@Injectable()
export class TempTokenService {


    constructor(private http: HTTP, private config: ConfigurationManager) { }

    getTemparoryToken(data) {
        const apiKey = 'a4e0c54d-113a-45aa-99c1-8cf2fb249e46';
        const authString: string = (this.config.getAuthinticated) ? apiKey + ':' + this.config.getCustomerToken : apiKey + ':' + apiKey;
        // +this.config.environmentConfig.apikey;
        const encodedAuthString = btoa(authString);
        const authHeaderValue = 'Basic ' + encodedAuthString;

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': authHeaderValue,
            'Accept': 'application/json'
        };


        const body = {
        };

        console.log('params' + body);
        const url = 'https://mobileapi.autoclubgroup.com/api/v4/authentication/temptokens';
        this.http.setDataSerializer('json');
        return this.http.post(url, body, headers);

    }

}
